// extracted by mini-css-extract-plugin
export default {"body":"security_body__-6Ft7"};